
// react-bootstrap imports
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Button } from "react-bootstrap"
import Form from "react-bootstrap/Form"

// components imports
import { LoadingSpinner } from "components/Helpers"
import { BotaoAutoPreenchimento } from "components/BotoesAuxiliaresDev"
import { autoFillWithCache, BotaoLoading, saveInputInCache } from "components/FormGerarGuia"
import { ErrorChamadaApiMessage, SuccessDataSaved, SuccessDocumentoGerado, WarningIncompleteInput, WarningNoData } from "components/AlertMessages"

// service imports
import * as service from "services/TaxasCTM24/CalcularTaxaServico/GerarMulta"

// assets imports
import stdStyle from "json/StdStyles.json"
import { section } from "services/InputFieldsMulta"
import { BotaoVoltar } from "components/Helpers"


const BotaoAtualizarMulta = ({ isLoading }) =>
{
    if (isLoading) { return <BotaoLoading />}

    return <Button className={stdStyle.button} variant="success" type="submit">Atualizar multa</Button>
}

const BotaoBaixarMulta = ({ isLoading }) =>
{
    if (isLoading) { return <BotaoLoading />}

    return <Button className={stdStyle.button} variant="success" type="submit">Baixar multa</Button>
}

const BotaoSalvarDados = ({ setShowAlertDataSaved }) =>
{
    return <Button className="rounded-5"  variant="outline-primary" onClick={() => {saveInputInCache(setShowAlertDataSaved)}}>Salvar dados</Button>
}

const BotaoCarregarDados = ({ setShowAlertNoData }) =>
{
    return <Button className="rounded-5" variant="outline-primary" onClick={() => {autoFillWithCache(setShowAlertNoData)}}>Carregar dados</Button>
}

const Botoes = ({ modoEditar, isLoading, linkPrevPage, statePrevPage, setAlerts }) =>
{
    const divStyle = "d-flex justify-content-around mb-2 mt-2"
    // TODO alerts
    return (
        <>
            <hr className="text-primary opacity-100" />
            <div className={divStyle} >
                <BotaoVoltar linkPrevPage={linkPrevPage} statePrevPage={statePrevPage} />
                { modoEditar ? <BotaoAtualizarMulta isLoading={isLoading} /> : <BotaoBaixarMulta isLoading={isLoading} /> }
            </div>
            <div className={divStyle}>
                <BotaoSalvarDados setShowAlertDataSaved={setAlerts}  />
                <BotaoCarregarDados setShowAlertNoData={() => {}} />
            </div>
        </>
    )
}

const Messages = ({ showAlertNoData, showWarningInputsNotValid, showAlertDataSaved, showAlertDataLoaded, showSuccessDocumentoGerado, showErrorMessage,
    setShowAlertNoData, setShowAlertInputsNotValid, setShowAlertDataSaved, setShowAlertDataLoaded, setShowSuccessDocumentoGerado, setShowErrorMessage }) =>
{
    return (
    <>
        <WarningNoData show={showAlertNoData} setShow={setShowAlertNoData} />
        <WarningIncompleteInput show={showWarningInputsNotValid} setShow={setShowAlertInputsNotValid} />
        <SuccessDataSaved show={showAlertDataSaved} setShow={setShowAlertDataSaved} />
        <SuccessDocumentoGerado show={showSuccessDocumentoGerado} setShow={setShowSuccessDocumentoGerado} />
        <ErrorChamadaApiMessage apiName={"gerador de documentos"} show={showErrorMessage} setShow={setShowErrorMessage} />  
    </>
    )
}

export const GerarMultaScreen = () =>
{
    const location = useLocation()
    let { servicoTaxa, dadosMulta, taxInputs, taxResults } = location.state
    const {linkPrevPage, statePrevPage} = location.state

    const [switchCNPJ, setSwitchCNPJ] = useState(false)
    const [expandedForm, setExpandedForm] = useState(false)
    const [amountGroupFields, setAmountGroupFields] = useState(false)

    const [isLoading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false)
    const [showAlertNoData, setShowAlertNoData] = useState(false)
    const [showAlertDataSaved, setShowAlertDataSaved] = useState(false)
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [showAlertDataLoaded, setShowAlertDataLoaded] = useState(false)
    const [showWarningInputsNotValid, setShowAlertInputsNotValid] = useState(false)
    const [showSuccessDocumentoGerado, setShowSuccessDocumentoGerado] = useState(false)

    useEffect(() => {
        setAmountGroupFields(
            {
                "docsOrigemMulta": dadosMulta?.detalhesMulta?.docsOrigemMulta?.length ?? 0,
                "testemunha": dadosMulta?.detalhesMulta?.testemunha?.length ?? 0
            }
        )
        setExpandedForm(true)
    }, [expandedForm, dadosMulta])

    useEffect(() => {
        service.autoFillMulta(dadosMulta)
    }, [amountGroupFields, dadosMulta])


    const onFormSubmit = async event => {        
        service.handleSubmit(event, setValidated, setShowAlertInputsNotValid, setLoading, setShowSuccessDocumentoGerado, setShowErrorMessage,
            dadosMulta, servicoTaxa.id, servicoTaxa.nome, taxInputs, taxResults)
        // navigate(Links.HOME)
    }

    const onChangeCPFCNPJ = () => { service.onChangeCPFCNPJ(setSwitchCNPJ) }

    const maskPlaceholderCpfCnpj = switchCNPJ ? "99.999.999/9999-99" : "999.999.999-99"

    return (
        <>
            <Messages showAlertNoData={showAlertNoData} showWarningInputsNotValid={showWarningInputsNotValid} showAlertDataSaved={showAlertDataSaved}
            showAlertDataLoaded={showAlertDataLoaded} showSuccessDocumentoGerado={showSuccessDocumentoGerado} showErrorMessage={showErrorMessage}
            setShowAlertNoData={setShowAlertNoData} setShowAlertInputsNotValid={setShowAlertInputsNotValid} setShowAlertDataSaved={setShowAlertDataSaved}
            setShowAlertDataLoaded={setShowAlertDataLoaded} setShowSuccessDocumentoGerado={setShowSuccessDocumentoGerado} setShowErrorMessage={setShowErrorMessage} />

            <Form className={stdStyle.formGuia} noValidate validated={validated} onSubmit={onFormSubmit}>

                {section.proprietario(onChangeCPFCNPJ, maskPlaceholderCpfCnpj, maskPlaceholderCpfCnpj)}
                {section.enderecoProprietario(false)}
                {section.documentoOrigem(amountGroupFields.docsOrigemMulta)}
                {section.vencimento()}

                <Botoes modoEditar={service.modoEditar(dadosMulta)} isLoading={isLoading} linkPrevPage={linkPrevPage} statePrevPage={statePrevPage} setAlerts={setShowAlertDataSaved}/>
                <BotaoAutoPreenchimento />

            </Form>

            <LoadingSpinner show={isLoading} />
        </>
    )
}